import { render, staticRenderFns } from "./menu-categories.vue?vue&type=template&id=7f8b09df"
import script from "./menu-categories.vue?vue&type=script&lang=ts"
export * from "./menu-categories.vue?vue&type=script&lang=ts"
import style0 from "./menu-categories.vue?vue&type=style&index=0&id=7f8b09df&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8b09df')) {
      api.createRecord('7f8b09df', component.options)
    } else {
      api.reload('7f8b09df', component.options)
    }
    module.hot.accept("./menu-categories.vue?vue&type=template&id=7f8b09df", function () {
      api.rerender('7f8b09df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/menu-categories.vue"
export default component.exports